import { RefObject, memo } from 'react'

import { useIsTextTruncated } from '@inno-tools/react-hooks'
import { Tooltip } from '@inno-ui/tooltip'
import cn from 'classnames'

import styles from './FolderViewItemInfo.module.scss'

export const FolderViewItemInfo = memo<{ info?: string }>(({ info }) => {
  const { isTruncated, textRef: infoRef } = useIsTextTruncated()

  return (
    <Tooltip overlay={info} disabled={!isTruncated}>
      <p
        className={cn(styles.info, 'itemInfo')}
        ref={infoRef as RefObject<HTMLParagraphElement>}
      >
        {info}
      </p>
    </Tooltip>
  )
})
